import { createSlice } from '@reduxjs/toolkit';
import { getCurrentStore, getCurrentStoreSettingsSetup, updateCurrentStore } from './thunk';

export type ISettingsSetup = {
  settingsAllowedServicesToEdit: string[];
  settingsPagesToShow: string[];
  resourcesToEdit: {
    resourceId: string;
    category: string;
    description: string;
    id: string;
  }[];
  servicesToEdit: {
    serviceId: string;
    category: string;
    description: string;
    id: string;
  }[];
};

type InitialState = {
  currentStore: any | null, // TODO add type
  settingsSetup: ISettingsSetup | null
  loading: boolean,
  settingsSetupLoading: boolean
};

const initialState: InitialState = {
  currentStore: null,
  loading: true,
  settingsSetup: null,
  settingsSetupLoading: true,
};

const slice = createSlice({
  name: 'store',
  initialState,
  reducers: {
    clearCurrentStore: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCurrentStore.fulfilled, (state, action) => {
        state.currentStore = action.payload;
        state.loading = false;
      })
      .addCase(getCurrentStore.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCurrentStore.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getCurrentStoreSettingsSetup.fulfilled, (state, action) => {
        state.settingsSetup = action.payload;
        state.settingsSetupLoading = false;
      })
      .addCase(getCurrentStoreSettingsSetup.pending, (state) => {
        state.settingsSetupLoading = true;
      })
      .addCase(getCurrentStoreSettingsSetup.rejected, (state) => {
        state.settingsSetupLoading = false;
      })
      .addCase(updateCurrentStore.fulfilled, (state, action) => {
        state.currentStore = action.payload;
        state.loading = false;
      })
      .addCase(updateCurrentStore.pending, (state) => {
        state.loading = true;
      });
  },
});

export const { clearCurrentStore } = slice.actions;
export default slice.reducer;
